module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/features/buttons/gradient-horizontal-buttons/gradient-horizontal-buttons.component.scss
// module id = ./src/app/features/buttons/gradient-horizontal-buttons/gradient-horizontal-buttons.component.scss
// module chunks = main